/**
 * Oglinda lui `looksLikeOcrNoise` din packages/doc-parsers (imaginea frontend nu
 * importă din afara apps/frontend). Marchează textul care pare citit greșit de OCR,
 * inclusiv în documentele procesate înainte ca verificarea să existe pe server.
 */
const LETTER = 'A-Za-zĂÂÎȘȚăâîșțŞŢşţ';
const SYMBOL_INSIDE_WORD = new RegExp(String.raw`[${LETTER}][%@#$&*{}<>|~^‘’“”«»=_]+[${LETTER}]`);
const QUOTE_BETWEEN_DIGITS = /\d[‘’“”]\d/;
const ALLOWED_CHAR = new RegExp(String.raw`[${LETTER}0-9\s.,;:()/%'"+\-–]`);

/** Câmpurile cu validare proprie (coduri, date) nu se verifică aici. */
const SKIP = new Set([
  'cnp',
  'hpBulletinNo',
  'principalIcd10',
  'hpTopographyIcd10',
  'icdO3Morphology',
  'birthDate',
  'admissionDate',
  'dischargeDate',
  'hpCollectedDate',
  'hpReceivedDate',
  'hpResultDate',
  'collectedAt',
  'consultDate',
  'documentDate',
  'consentStatus',
]);

export function looksLikeOcrNoise(text: string): boolean {
  if (!text || text.length < 4) return false;
  if (SYMBOL_INSIDE_WORD.test(text) || QUOTE_BETWEEN_DIGITS.test(text)) return true;
  if (text.length < 15) return false;
  let odd = 0;
  for (const ch of text) if (!ALLOWED_CHAR.test(ch)) odd++;
  return odd / text.length > 0.05;
}

/** Câmpurile text ale unui document care par citite greșit. */
export function noisyFields(fields: Record<string, unknown> | undefined): string[] {
  if (!fields) return [];
  return Object.entries(fields)
    .filter(([key, value]) => !SKIP.has(key) && typeof value === 'string' && looksLikeOcrNoise(value))
    .map(([key]) => key);
}
